/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentRunReportSummaryQuerySection extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AssessmentRunReportSummaryQuerySection");
    }

    getFixupPrototypeFunction() { return AssessmentRunReportSummaryQuerySection.fixupPrototype; }

    static newInstance(model: Partial<AssessmentRunReportSummaryQuerySection>): AssessmentRunReportSummaryQuerySection {
        let obj = Object.assign(new AssessmentRunReportSummaryQuerySection(), model);
        AssessmentRunReportSummaryQuerySection.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentRunReportSummaryQuerySection>): AssessmentRunReportSummaryQuerySection {
        if (!model) return null;
        return AssessmentRunReportSummaryQuerySection.newInstance(<AssessmentRunReportSummaryQuerySection> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentRunReportSummaryQuerySection) {
        if (!obj) return;

        models.AssessmentRunReportSummaryQuerySection.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentRunReportSummaryQuerySection): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AssessmentRunReportSummaryQuerySection.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Section of workload assessment detailed report
     */
    sections: Array<models.AssessmentRunReportSummarySection>;

}
